import type { Transition, Variants } from "framer-motion";

/* One easing family, so every surface in the product decelerates alike. */
export const EASE = [0.22, 1, 0.36, 1] as const;
export const EASE_IN_OUT = [0.83, 0, 0.17, 1] as const;

export const spring: Transition = { type: "spring", stiffness: 380, damping: 32, mass: 0.7 };
export const softSpring: Transition = { type: "spring", stiffness: 220, damping: 28 };

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: EASE } },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.4, ease: EASE } },
};

/* Section reveals stagger their children rather than animating as a block. */
export const stagger = (delayChildren = 0, staggerChildren = 0.05): Variants => ({
  hidden: {},
  show: { transition: { delayChildren, staggerChildren } },
});

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.96 },
  show: { opacity: 1, scale: 1, transition: { duration: 0.35, ease: EASE } },
  exit: { opacity: 0, scale: 0.97, transition: { duration: 0.18, ease: EASE_IN_OUT } },
};

/* Shared viewport config: reveal once, slightly before the edge. */
export const inView = { once: true, margin: "-80px 0px -80px 0px" } as const;
